module.exports = __webpack_public_path__ + "img/hr-dead-tree-desert-02.e353c38a.png";